// extracted by mini-css-extract-plugin
export var externalLink = "_ad-0";
export var internalLinkLabel = "_ad-1";